module.exports = __webpack_public_path__ + "static/media/22-7.d89cb208.mp3";